enum CONFIG {
	DEFAULT_GET_SIZE_ITEM_PAGE = 20,
}

export default CONFIG;
